module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Silk Studio","short_name":"Silk Studio","start_url":"/","background_color":"#171717","theme_color":"#fefefe","display":"minimal-ui","icon":"src/assets/icons/silk_favicon.svg","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"070549a6dcc9ea99da600c46f824d090"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
